import { render } from "./TaxesTab.vue?vue&type=template&id=c429b7c4&scoped=true"
import script from "./TaxesTab.vue?vue&type=script&lang=js"
export * from "./TaxesTab.vue?vue&type=script&lang=js"

import "./TaxesTab.vue?vue&type=style&index=0&id=c429b7c4&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c429b7c4"]])

export default __exports__